import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { DisStartingModel } from '../models/DisStartingModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class DisStartingService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getDisStarting(discode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("DisCode", discode);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<DisStartingModel>(this.urlsconfig.WebAPIURL_Test + 'api/DisStarting/GetDisStarting',options);
    }


    public AddDisStarting(endoInv: DisStartingModel) {
      return this.http.post<DisStartingModel>(this.urlsconfig.WebAPIURL_Test + 'api/DisStarting/AddDisStarting', endoInv);
    }

  }
